import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { RadioGroup, FormControlLabel, Radio, FormLabel, FormHelperText, Checkbox, Button } from "@mui/material";

const RadioButtonController = ({ name, isDisabled=false, isLabel=false, label, control, options, isRow=false,
   errors,  isMargin=true }) => {

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {isLabel && <FormLabel component="legend" sx={{ fontSize: "14px", minWidth:"120px", color:(theme)=>theme.palette.black.main}}>{label} :</FormLabel>}
            <RadioGroup {...field} row={isRow} sx={{ flexGrow: 1}}>
              {options.map((option, index) => (
                <FormControlLabel
                  sx={{ marginRight: !isMargin ? "0px" : undefined, "& .MuiFormControlLabel-label.Mui-disabled":{
                                        color:(theme)=>theme.palette.black.main,
                                    },
                                     "&.MuiFormControlLabel-root>span":{
                    fontSize:"14px",
                  }}}
                  key={index}
                  disabled={isDisabled}
                  value={option.value}
                  control={<Radio size="small" sx={{ padding: "0rem 4px",
                      "&.Mui-disabled": {
                        color: (theme)=>theme.palette.primary.main,
                      },
                    }} />}
                  label={option.label}
                />
              ))}
            </RadioGroup>
            {errors[name] && <FormHelperText error>{errors[name].message}</FormHelperText>}
          </>
        )}
      />
    </>
  );
};

export default RadioButtonController;


export const CheckBoxLikeRadio = ({ name, isDisabled=false, isLabel=false, label, control, options, isRow=false,
  errors,  isMargin=true  })=> {
  return(
    <>
   <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            {isLabel && <FormLabel component="legend" sx={{ fontSize: "14px", minWidth:"120px", color:(theme)=>theme.palette.black.main}}>{label} :</FormLabel>}
            {options.map((option, index) => (
              <FormControlLabel
                sx={{ marginRight: !isMargin ? "0px" : undefined, "& .MuiFormControlLabel-label.Mui-disabled":{
                                      color:(theme)=>theme.palette.black.main,
                                  },
                                  marginLeft: "0px",
                                   "&.MuiFormControlLabel-root>span":{
                  fontSize:"14px",
                  
                }}}
                key={index}
                disabled={isDisabled}
                control={
                  <Checkbox
                    checked={field.value === option.value}
                    icon={<span className="radio"/>}
                    checkedIcon={<span className="radio checked"/>}
                    onChange={(e) => {
                      // console.log("e", e.target.checked, option.value)
                      if (e.target.checked) {
                        field.onChange(option.value);
                      } else {
                        field.onChange(null);
                      }
                    }}
                  />
                }
                label={option.label}
              />
            ))}
            {errors[name] && <FormHelperText error>{errors[name].message}</FormHelperText>}
          </>
        )}
      />
        </>
  )
}
